import { gql } from '@apollo/client';

export const DELETE_INTERVENTION = gql`
  mutation deleteIntervention($id: ID!) {
    intervention: deleteIntervention(id: $id) {
      id
      name
    }
  }
`;
